// extracted by mini-css-extract-plugin
module.exports = {"SolarInput":"SolarInput_SolarInput__qFdjr"};